/**
* 最大幅に基づいてviewport設定を切り替える関数。
* @function
* @param {number} maxWidth - viewportを固定する際の最大幅
*/
// const switchViewport = (maxWidth) => {
//   const viewport = document.querySelector('meta[name="viewport"]');
//   const value =
//     window.outerWidth > maxWidth
//       ? "width=device-width,initial-scale=1"
//       : `width=${maxWidth}`;
//   if (viewport.getAttribute("content") !== value) {
//     viewport.setAttribute("content", value);
//   }
// };
// addEventListener("resize", () => switchViewport(375));
// switchViewport(375);

// import './parts/_smooth.js';


(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth > 375
        ? window.outerWidth > 1920
          ? "width=1920"
          : "width=device-width,initial-scale=1"
        : "width=375";
    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }
  window.addEventListener("resize", switchViewport, false);
  switchViewport();
})();




const pickupSlider = new Swiper('.p-pickup__swiper', { //swiperの名前
  //切り替えのモーション
  speed: 1000, //表示切り替えのスピード
  effect: "slide", //切り替えのmotion (※1)
  allowTouchMove: true, // スワイプで表示の切り替えを有効に

  //最後→最初に戻るループ再生を有効に
  loop: true,
  //自動スライドについて
  autoplay: { 
    delay: 5000, //何秒ごとにスライドを動かすか
    stopOnLastSlide: false, //最後のスライドで自動再生を終了させるか
    disableOnInteraction: true, //ユーザーの操作時に止める
    reverseDirection: false, //自動再生を逆向きにする
  },

   //表示について
  centeredSlides: true, //中央寄せにする
  slidesPerView: "auto",
  spaceBetween: 15,

  //ページネーション
  pagination: {
    el: ".swiper-pagination", //paginationのclass
    clickable: true, //クリックでの切り替えを有効に
    type: "bullets" //paginationのタイプ (※2)
  },
  //ナビゲーション
  navigation: {
    prevEl: ".swiper-button-prev", //戻るボタンのclass
    nextEl: ".swiper-button-next" //進むボタンのclass
  },
  //スクロールバー
  scrollbar: { //スクロールバーを表示したいとき
    el: ".swiper-scrollbar", //スクロールバーのclass
    hide: true, //操作時のときのみ表示
    draggable: true //スクロールバーを直接表示できるようにする
  },

  //ブレイクポイントによって変える
  breakpoints: { 
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  }
});


// フェードイン
const fadeIns = document.querySelectorAll('.js-fadeIn');
fadeIns.forEach((fadeIn) => {
  gsap.fromTo(
    fadeIn,
    {
      // from properties
      opacity: 0,
     y: 20,
    },
    {
      // to properties
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.inOut",
      scrollTrigger: {
        trigger: fadeIn,
        start: "top 90%",
      }
    }
  );
});

// stagger
const staggers = document.querySelectorAll('.js-stagger');
staggers.forEach((stagger) => {
  gsap.fromTo(
    stagger.querySelectorAll('.js-stagger-item'),
    {
      // from properties
      opacity: 0,
      y: 20,
    },
    {
      // to properties
      opacity: 1,
      y: 0,
      stagger: 0.1,
      scrollTrigger: {
        trigger: stagger,
        start: "top 90%",
      }
    }
  );
});

// stagger（PCのみ：768px以上で発火）
const initStaggerPc = () => {
  const staggerPcs = document.querySelectorAll('.js-stagger-pc');
  staggerPcs.forEach((staggerPc) => {
    gsap.fromTo(
      staggerPc.querySelectorAll('.js-stagger-item'),
      {
        // from properties
        opacity: 0,
        y: 20,
      },
      {
        // to properties
        opacity: 1,
        y: 0,
        stagger: 0.1,
        scrollTrigger: {
          trigger: staggerPc,
          start: "top 90%",
        }
      }
    );
  });
};

if (typeof gsap !== "undefined" && typeof gsap.matchMedia === "function") {
  gsap.matchMedia().add("(min-width: 768px)", () => {
    initStaggerPc();
  });
} else if (window.matchMedia("(min-width: 768px)").matches) {
  initStaggerPc();
}

gsap.fromTo(
  '.p-middle__content svg',
  {
    opacity: 0,

  },
  {
    opacity: 1,
 
    duration: 0.6,
    stagger: 0.1,
    scrollTrigger: {
      trigger: '.p-middle__content svg',
      start: "top 80%",
    }
  }
);


document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('a[href^="#"]');
  links.forEach(item => {
    item.addEventListener("click", event => {
      event.preventDefault();
      const targetId = item.getAttribute("href");
      const target = document.querySelector(targetId);
      if (target) {
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  let toTopButton = document.querySelector('.p-to-top');

  // スクロールイベントを監視してTo Topボタンを制御
  window.addEventListener('scroll', function() {
    // 現在のスクロール位置を取得
    let scrollPosition = window.scrollY || document.documentElement.scrollTop;

    // スクロール位置が一定値よりも大きい場合にTo Topボタンを表示、それ以外は非表示にする
    if (scrollPosition > 300) {
      toTopButton.classList.add("js-show");
    } else {
      toTopButton.classList.remove("js-show");
    }
  });

  // To Topボタンがクリックされたときにページの先頭にスクロールする
  toTopButton.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});
